export default function formatAssetName(asset) {
  let name = '';
  if(asset.year) {
    name += asset?.year;
  }
  if(asset.make) {
    name += ` ${asset?.make}`;
  }
  if(asset.model) {
    name += ` ${asset?.model}`;
  }
  if(asset.type) {
    name += ` ${asset?.type}`
  }

  return name;
}